export default "__VITE_ASSET__82768687__"